import { WrapperPageCloseButton } from '../../WrapperPage/present/PageElements'
import Newsletter from './Newsletter'

const NewsletterPreview = ({closePagePath, stylesFontFaces, styles, currentCinemaUrl, stylesData, imageItems, textItems, socialMediaData, structureData, cinemaData, cinemasData, newsletterData, ads, highlights, movieData, routeMovies, allPerformances, closingTextLines, translation}) => (
    <div className={"newsletter-page-preview"  + (stylesData.themeColors ? ' ' + stylesData.themeColors.toLowerCase() : '')}>
        <div className="button-back-wrapper">
            <WrapperPageCloseButton closePagePath={closePagePath} />
        </div>
        <style type="text/css">{stylesFontFaces}</style>
        <style type="text/css">{styles}</style>
        <Newsletter 
            stylesData={stylesData}
            structureData={structureData}
            cinemaData={cinemaData}
            cinemasData={cinemasData}
            currentCinemaUrl={currentCinemaUrl}
            newsletterData={newsletterData}
            ads={ads}
            textItems={textItems}
            imageItems={imageItems}
            socialMediaData={socialMediaData}
            highlights={highlights}
            movieData={movieData}
            routeMovies={routeMovies}
            allPerformances={allPerformances}
            closingTextLines={closingTextLines}
            translation={translation}
        />
    </div>
)

export default NewsletterPreview